import anime from 'animejs/lib/anime.es.js';
import AOS from 'aos-container';
import { debounce } from "debounce";

const initSevp = () => {
	const sevp = document.querySelector(".sevp");
	if (!sevp) {
		return;
	}

	AOS.init({
		container: ".sevp",
		duration: 600,
		offset: 0,
	});

	const slides = sevp.querySelectorAll(".slide");
	const whitePuzzle = sevp.querySelector("#whitePuzzle");
	const bluePuzzle = sevp.querySelector("#bluePuzzle");
	const whitePuzzle1 = sevp.querySelector("#whitePuzzle1");
	const whitePuzzle2 = sevp.querySelector("#whitePuzzle2");
	const whitePuzzle3 = sevp.querySelector("#whitePuzzle3");
	const bluePuzzle1 = sevp.querySelector("#bluePuzzle1");
	const bluePuzzle2 = sevp.querySelector("#bluePuzzle2");
	const bluePuzzle3 = sevp.querySelector("#bluePuzzle3");
	const close = sevp.querySelector('.close');
	const ref = document.referrer;

  if (ref.includes('bmofundcentral.com') || ref.includes('centrefondsbmo.com')){
		close.setAttribute('href', ref);
	} else {
		close.setAttribute('href', window.location.origin);
	}

	const createAnimation = () => {
		const duration = 600;
		let raf = null; //requestAnimationFrame

		const getOffset = (element) =>
		{
			var bound = element.getBoundingClientRect();
			var html = document.documentElement;

			return {
				top: bound.top + window.pageYOffset - html.clientTop,
				left: bound.left + window.pageXOffset - html.clientLeft
			};
		}

		const timeline1 = anime.timeline({
			easing: "linear",
			duration: duration,
			autoplay: false,
		});

		timeline1.add({
			targets: whitePuzzle,
			translateX: [getOffset(whitePuzzle1).left, getOffset(whitePuzzle2).left],
			translateY: [getOffset(whitePuzzle1).top, getOffset(whitePuzzle2).top],
			scale: [whitePuzzle1.getBoundingClientRect().width/whitePuzzle.getBBox().width, whitePuzzle2.getBoundingClientRect().width/whitePuzzle.getBBox().width],
		}, 0);
		
		timeline1.add({
			targets: bluePuzzle,
			translateX: [getOffset(bluePuzzle1).left, getOffset(bluePuzzle2).left],
			translateY: [getOffset(bluePuzzle1).top, getOffset(bluePuzzle2).top],
			scale: [bluePuzzle1.getBoundingClientRect().width/bluePuzzle.getBBox().width, bluePuzzle2.getBoundingClientRect().width/bluePuzzle.getBBox().width],
		}, 0);
		
		timeline1.add({
			targets: whitePuzzle,
			translateX: [getOffset(whitePuzzle2).left, getOffset(whitePuzzle3).left],
			translateY: [getOffset(whitePuzzle2).top, getOffset(whitePuzzle3).top],
			scale: [whitePuzzle2.getBoundingClientRect().width/whitePuzzle.getBBox().width, whitePuzzle3.getBoundingClientRect().width/whitePuzzle.getBBox().width],
		}, duration);
		
		timeline1.add({
			targets: bluePuzzle,
			translateX: [getOffset(bluePuzzle2).left, getOffset(bluePuzzle3).left],
			translateY: [getOffset(bluePuzzle2).top, getOffset(bluePuzzle3).top],
			scale: [bluePuzzle2.getBoundingClientRect().width/bluePuzzle.getBBox().width, bluePuzzle3.getBoundingClientRect().width/bluePuzzle.getBBox().width],
		}, duration);

		const seekAnimation = () => {
	
			const scrollPercent = () => {
				const docST = sevp.scrollTop;
				const scrollPercent = (docST) / (slides[0].getBoundingClientRect().height + slides[1].getBoundingClientRect().height);

				return scrollPercent;
			}

			if(scrollPercent() <= 1){
				var progress = timeline1.progress / 100;
				var diff = scrollPercent() - progress;
		
				progress += diff * 0.1;    
				timeline1.seek((progress) * timeline1.duration);
			
				if (Math.abs(diff) > 0.000005) {
					raf = requestAnimationFrame(seekAnimation);  
				} else if (raf !== null) {
					cancelAnimationFrame(raf);
					raf = null;
				}
			} else {
				if (raf !== null) {
					cancelAnimationFrame(raf);
					raf = null;
				}
			}
		};

		anime.set(whitePuzzle, {
			translateX: function() { return getOffset(whitePuzzle1).left; },
			translateY: function() { return getOffset(whitePuzzle1).top; },
			scale: function() { return whitePuzzle1.getBoundingClientRect().width/whitePuzzle.getBBox().width; },
		});

		anime.set(bluePuzzle, {
			translateX: function() { return getOffset(bluePuzzle1).left; },
			translateY: function() { return getOffset(bluePuzzle1).top; },
			scale: function() { return bluePuzzle1.getBoundingClientRect().width/bluePuzzle.getBBox().width; },
		});

		sevp.classList.add("loaded");

		sevp.addEventListener("scroll", () => {
			if (raf === null) {
				raf = requestAnimationFrame(seekAnimation);
			}
		});
	}

	window.addEventListener("load", () => {
		createAnimation();
	});

	addEventListener("resize", () => {
		sevp.classList.remove("loaded");
		anime.remove([bluePuzzle, whitePuzzle]);
		createAnimation();
	});

	const sevpSlides = () => {
		let unscrollable = true;
		let activeSlide = sevp.querySelector(".slide");
		let lastSlideActive = false;
		let lastMouseWheelStep = 0;

		const carets = sevp.querySelector(".carets");

		const navigate = (direction) => {
			let targetSlide = activeSlide;

			switch (direction) {
				case "previous":
					targetSlide = activeSlide.previousElementSibling;
					break;
				case "next":
					targetSlide = activeSlide.nextElementSibling;
					break;
			}

			if(targetSlide && (targetSlide.closest(".slide") instanceof HTMLElement && direction)){
				activeSlide = targetSlide;

				if(navigator.userAgent.toLowerCase().includes('firefox')){
					// Is Firefox; prevent APZ
					setTimeout(() => {
						targetSlide.scrollIntoView();
					}, 250);
				} else {
					uss.scrollIntoView(targetSlide, true, true, () => {
						targetSlide.scrollIntoView({ behavior: "smooth"});
					}, true);
				}
			}

			const nextSlide = activeSlide.nextElementSibling;
			const previousSlide = activeSlide.previousElementSibling;

			if(previousSlide && !(previousSlide.closest(".slide") instanceof HTMLElement)){
				document.querySelector(".js-previous").classList.add("hidden");
			} else {
				document.querySelector(".js-previous").classList.remove("hidden");
			}

			if(!nextSlide || !(nextSlide.closest(".slide") instanceof HTMLElement)){
				// Last slide
				document.querySelector(".js-next").classList.add("hidden");
				carets.classList.remove("md:mb-6");
				unscrollable = false;
				lastSlideActive = true;
			} else {
				carets.classList.add("md:mb-6");
				document.querySelector(".js-next").classList.remove("hidden");
				unscrollable = true;
				if(direction){
					lastSlideActive = false;
					setTimeout(() => {
						sevp.classList.remove("last-slide");
					}, 500);
				}
			}
		}
		
		addEventListener("click", (e) => {
			if ((e.target.closest(".js-next") instanceof HTMLButtonElement)) {
				navigate("next");
			}
			if ((e.target.closest(".js-previous") instanceof HTMLButtonElement)) {
				navigate("previous");
			}
		});

		const setActiveSlide = new IntersectionObserver((entries) => {
			if (entries[0].intersectionRatio > 0) { // If in view
				if(entries[0].isIntersecting && activeSlide != entries[0].target){
					unscrollable = true;
					activeSlide = entries[0].target;
					navigate(lastSlideActive);
				}
			}
		}, {
			threshold: 0.2,
		});

		slides.forEach((slide) => {
			setActiveSlide.observe(slide);
		});

		// Handle wheel
		const handleScroll = (e) => {
			if(!unscrollable ||
				e.target.closest(".disclaimer") instanceof HTMLElement
			){
				return;
			}
			if( Date.now() - lastMouseWheelStep > 1000) {
				lastMouseWheelStep = Date.now();

				let delta = -e.wheelDelta;

				if (delta < 0) {
					//scroll wheel up
					if(lastSlideActive){
						debounce(navigate(true), 200, true);
					} else {
						debounce(navigate("previous"), 200, true);
					}
				}
				if (delta > 0) {
					//scroll wheel down
					debounce(navigate("next"), 200, true)
				}
			}
		}

		sevp.addEventListener("wheel", (e) => {
			if (e.target.closest(".disclaimer") instanceof HTMLElement){
				return;
			}
			if(unscrollable){
				e.preventDefault();
			}
		}, {passive: false});
		sevp.addEventListener("wheel", debounce(handleScroll, 200, false), false);

		// Handle keypresses
		addEventListener("keydown", (e) => {

			switch (e.code) {
				case "ArrowUp":
					e.preventDefault();
					navigate("previous");
					break;
				case "ArrowDown":
				case "Space":
					e.preventDefault();
					navigate("next");
					break;
			}
		});
	}
	
	sevpSlides();
};

export default initSevp();
